import { Controller } from 'stimulus';

class ClickableBlockController extends Controller {
  connect() {
    this.onClickBound = this.onClick.bind(this);
    this.element.addEventListener('click', this.onClickBound);
  }

  disconnect() {
    this.element.removeEventListener('click', this.onClickBound);
  }

  onClick(event) {
    const link = this.findLink(event.target);

    if (!link) {
      return true;
    }

    const target = link.getAttribute('target')
      ? link.getAttribute('target')
      : '_self';

    window.open(link.href, target);

    return false;
  }

  findLink(node) {
    if (typeof node.closest !== 'function') {
      return null;
    }

    if (node.closest('a')) {
      return null;
    }

    return this.element.querySelector('a');
  }
}

ClickableBlockController.targets = [
  //
];

export default ClickableBlockController;
